import {
    ICheckboxGroup,
    IFormSection,
    isCheckboxGroup,
    isCmsSelect
} from '../domain/entities/Config';
import { query, serviceQueries } from '@estee/elc-service-bus';
import { observable } from 'mobx';
import { ITranslationsCollection } from '@estee/elc-service';
import { union } from 'lodash';

export class TranslationRepository {
    @observable public translations: ITranslationsCollection = {};

    // Get all translation keys within sections.
    public getSignUpTranslations = async (sections: IFormSection[]) => {
        const allKeys = union(
            sections.reduce(
                (keys, section) => {
                    const { titleLabelKey, items } = section;
                    items.forEach((item) => {
                        if (isCheckboxGroup(item)) {
                            const {
                                items: checkboxes,
                                selectAll,
                                labelKey
                            } = item as ICheckboxGroup;
                            // Checkbox group title
                            labelKey && keys.push(labelKey);
                            checkboxes.forEach((checkbox) => keys.push(checkbox.labelKey));
                            if (selectAll?.labelKey) {
                                // Select all option label
                                keys.push(selectAll.labelKey);
                            }
                        } else {
                            const { labelKey, errorMessages } = item;
                            keys.push(labelKey);
                            if (errorMessages) {
                                keys.splice(0, 0, ...Object.values(errorMessages));
                            }
                            if (isCmsSelect(item)) {
                                keys.push(item.source.value);
                            }
                        }
                    });
                    titleLabelKey && keys.push(titleLabelKey);

                    return keys;
                },
                [
                    'submitLabel',
                    'loadingLabel',
                    'selectLabel',
                    'passwordRequiredMessage',
                    'passwordStrengthFailedResetPasswordError'
                ]
            )
        );

        this.translations = await query(serviceQueries.GET_TRANSLATIONS, allKeys);
    };
}
